<template>
    <div>
        <div style="background-color: #fafafa;line-height: 49px;height: 49px;">
            <el-checkbox class="ml10" v-if="shopTags.length > 0" :disabled="readOnly" :indeterminate="isIndeterminate" v-model="checked" @change="handleCheckAllChange">
                <span>全选</span>
            </el-checkbox>
            <button @click="updateComRole();" style="float: right;margin-top: 8px;" class='swb-btn swb-btn-small mr15' v-if="!readOnly">
                <span>保存</span>
            </button>
        </div>
        <div class="table-layout">
            <ul v-if="shopTags.length > 0" class="switch-list clearfix ml10 mt10">
                <el-checkbox-group @change="handleCheckedChange" v-model="subShopFilterTagList">
                    <li v-for="shopTag in shopTags" class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                        <el-checkbox :disabled="readOnly" :label="shopTag.id">
                            <span>{{shopTag.name}}</span>
                        </el-checkbox>
                    </li>
                </el-checkbox-group>
            </ul>
            <ul v-if="shopTags == null || shopTags.length <= 0" style="margin-top: 50px;" class="switch-list clearfix ml10">
                <li class="switch-item ellipsis-1" style="width: auto;margin-right: 30px;">
                    <span>暂无数据</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import retailerApi from '../../api/retailer'
    import retailerAuthxApi from '../../api/retailerAuthx'

    export default {
        name: 'swb-com-role-shop-tag',
        desc: '公司岗位-机构标签',
        props: {
            roleId: {
                type: Number,
                default: null
            },
            readOnly: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                shopTags: [],
                comRole: null,
                subShopFilterTagList: [],
                checked: false,
                isIndeterminate: false
            }
        },
        created: function () {
            this.getShopTag();
        },
        methods: {
            getRetailerComRole: function () {
                let self = this;
                let postData = {
                    id: self.roleId,
                };
                retailerAuthxApi.getRetailerComRole(postData, function (retult) {
                    if(retult.type == "info") {
                        let comRole = retult.data;
                        self.comRole = comRole;
                        let subShopFilterTags = comRole.subShopFilterTags;
                        if(subShopFilterTags != null) {
                            self.subShopFilterTagList = subShopFilterTags.split('|');
                            self.checked = self.subShopFilterTagList.length >= self.shopTags.length;
                            self.isIndeterminate = self.subShopFilterTagList.length > 0 && self.subShopFilterTagList.length < self.shopTags.length;
                        }
                    } else {
                        MsgBox.warning(retult.message);
                    }
                });
            },
            getShopTag: function () {
                let postData = {};
                let self = this;
                let loading = MsgBox.loading();
                retailerApi.getRetailerShopTagList(postData, function (result) {
                    loading.hide();
                    if(result.type == "info") {
                        self.shopTags = result.data || [];
                        self.getRetailerComRole();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleCheckAllChange: function (checked) {
                let subShopFilterTagList = [];
                if(checked) {
                    this.shopTags.forEach(function (item) {
                        subShopFilterTagList.push(item.id);
                    });
                }
                this.isIndeterminate = false;
                this.subShopFilterTagList = Utils.merge([], subShopFilterTagList);
            },
            handleCheckedChange(value) {
                let checkedCount = value.length;
                this.checked = checkedCount >= this.shopTags.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.shopTags.length;
            },
            updateComRole(){
                let self = this;
                let subShopFilterTagList = this.subShopFilterTagList;
                let subShopFilterTags = null;
                if(subShopFilterTagList.length > 0) {
                    subShopFilterTags = subShopFilterTagList.join('|');
                }
                let postData = {
                    id: self.roleId,
                    subShopFilterTags: subShopFilterTags
                };
                let loading = MsgBox.loading();
                retailerAuthxApi.updateRetailerComRoleSubShopFilterTags(postData, function (result) {
                    loading.hide();
                    if(result.type == "info") {
                        self.$message.success("操作成功");
                        self.getRetailerComRole();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/ComRoleShopTag.vue